import { SET_USER, SET_INFO } from "../actions/rent.actions";

export const rentReducer = (state, action) => {
    switch(action.type) {
        case SET_USER:
            const user = action.payload;
            return { ...state, user: {...user} };
        case SET_INFO:
            const info = action.payload;
            return { ...state, info: {...info} };
        default:
            return state;
    }
}